import styled from "styled-components";
import { SIDEBAR_W } from "../../config/layout";

export const TOPBAR_H  = "68px";

export const Sidebar = styled.aside`
  width: ${SIDEBAR_W};
  min-width: ${SIDEBAR_W};
  background: #fff;
  display: flex;
  flex-direction: column;
  position: fixed;
  top: ${TOPBAR_H}; left: 0; bottom: 0;
  z-index: 100;
  border-right: 1px solid #e0e8f0;
`;

export const PatientPreview = styled.div`
  padding: 14px 18px;
  display: flex;
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid #e8f0f7;
  background: #f8fbfd;
`;

export const PreviewAvatar = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  background: #e8f0f7;
  flex-shrink: 0;
`;

export const PreviewCode = styled.span`
  color: #1b3a6b;
  font-size: 0.78rem;
  font-weight: 600;
  word-break: break-all;
`;

export const Nav = styled.nav`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-top: 4px;
`;

export const NavItem = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 13px 18px;
  background: ${({ $active }) => ($active ? "#79BEE6" : "none")};
  border: none;
  color: ${({ $active }) => ($active ? "#ffffff" : "#555")};
  font-size: 0.85rem;
  font-weight: ${({ $active }) => ($active ? 600 : 400)};
  text-align: left;
  cursor: pointer;
  width: 100%;

  &:hover {
    background: ${({ $active }) => ($active ? "#79BEE6" : "#f0f6f8")};
    color: ${({ $active }) => ($active ? "#fff" : "#26A9B6")};
  }
`;

/* Va detrás del texto, en el flujo normal: así crece con el número de dígitos
   en lugar de tapar el icono. */
export const NavBadge = styled.span`
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  margin-left: 8px;
  border-radius: 9px;
  background: #e53e3e;
  color: #fff;
  font-size: 0.68rem;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const SidebarBottom = styled.div`
  background: #f5f7f9;
  border-top: 1px solid #e0e8f0;
  padding: 8px 0 4px;
`;

export const ReviewFormBtn = styled.button`
  margin: 4px 14px 8px;
  padding: 7px 12px;
  border-radius: 16px;
  border: 1.5px solid #26A9B6;
  background: #fff;
  color: #26A9B6;
  font-size: 0.78rem;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;

  &:hover { background: #f0fbfc; }
`;

export const SidebarLink = styled.a`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 18px;
  color: #555;
  font-size: 0.82rem;
  text-decoration: none;
  cursor: pointer;

  &:hover { color: #26A9B6; background: #edf3f5; }
`;
